export default __webpack_public_path__ + "person.7155c0a43cbea856.svg";